
import { RUNREVERSEGEOCODING_TYPES } from '../actions/runReverseGeocoding'
import reducer, { defaultState } from './requests'
const Reducer = (state = defaultState, action) => {
    let requestReducer = reducer(RUNREVERSEGEOCODING_TYPES)(state, action)
    if (requestReducer !== null) return requestReducer
    switch (action.type) {
        default:
            return state
    }
}
export default Reducer